var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"announcements-notices"},_vm._l((_vm.announcements),function(announcement){return _c('notice',{key:announcement.id,attrs:{"announcement":announcement},on:{"dismiss":function($event){return _vm.dismiss($event)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }